
<div class="{{type?'webview box':''}}">

<div class="container">
  <div class="{{type? 'sub-container-wv':'sub-container'}} ">

    <div class="{{type?'sub-container-column-wv':'sub-container-column'}} full-width align-start">
      <div><p id="p1" class="{{type? 'pd-l-1-wv pd-b-7-wv title-info-wv red-color-wv':'pd-l-1 pd-b-7 title-info red-color'}}  ">{{subsForm.get("packageDetails")?.get("availablePackageSelection")?.value?.packageTitle}}</p></div>
      <div class="{{type?'sub-container-column-wv align-start':'sub-container-column align-end'}} full-width ">
        <div class="margin-right-10">
          <div class="flex">
            <p id="p2" class="{{type?'pd-l-1-wv':'pd-l-1'}} font--13 text-sub-color-3 font-weight-400">
              {{subsForm.get("packageDetails")?.get("availablePackageSelection")?.value?.duration}} Subscription
            </p>
            <!-- <p id="p1" class="font--13 text-sub-color-3 font-weight-400 text-center-end">
                {{" - "+"$ " +subsForm.get("packageDetails").get("availablePackageSelection")?.value?.packagePrice}}/{{(subsForm.get("packageDetails").get("availablePackageSelection")?.value?.duration === "5 Year")? "5 Year":"3 Year"}}
              </p> -->
          </div>
          <!-- <p
            id="p2"
            *ngIf="subscription.pricePerMonth"
            [class]="getColorClass(subscription)"
          >
            {{
              subsForm.get("packageDetails").get("availablePackageSelection")
                ?.value?.pricePerMonth
            }}
            / Month
          </p> -->
          <!-- <p id="p3" [class]="getColorClass()">
          Expire at
          {{
            subsForm.get("packageDetails").get("availablePackageSelection")?.value
              ?.subsExpiryDate
          }}
        </p> -->
          <p id="p3" class="{{type?'pd-l-1-wv text-center-start':'pd-l-1 text-center-end'}} font--13 text-sub-color-3 font-weight-400 ">Starts at {{subsForm.get("packageDetails")?.get("availablePackageSelection")?.value
            ?.subsStartDate}}
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="{{type? 'sub-container-wv':'sub-container'}}">
    <div class="divider"></div>
  </div>

  <div class="{{type? 'sub-container-wv':'sub-container'}} ">
    <div class="{{type?'sub-container-column-wv':'sub-container-column'}} full-width align-start">
      <div>
        <p id="p1" class="{{type? 'pd-l-1-wv pd-b-7-wv title-info-wv red-color-wv':'pd-l-1 pd-b-7 title-info red-color'}}">
          Payment Method
        </p>
      </div>
      <div class="{{type?'sub-container-column-wv align-start':'sub-container-column align-end'}} full-width ">
        <div class="{{type?'align-start':'align-end margin-right-10 '}}">
          <ng-container *ngIf="subsForm.get('paymentDetails')?.get('availablePaymentMethodSelection')?.value as pm">
            <p id="p2" class="{{type?'pd-l-1-wv text-center-start':'pd-l-1 text-center-end'}}  font--13 text-sub-color-3 font-weight-400">
              <img *ngIf="pm.cc_type == 'Visa'" class="w-40px" src="../../../../../../../assets/LOGOS/visa-logo.svg" alt="Visa" />
              <img *ngIf="pm.cc_type == 'Maestro'" class="w-40px" src="../../../../../../../assets/LOGOS/maestroLogo.svg" alt="Maestro" />
              <img *ngIf="pm.cc_type == 'MasterCard' || pm.cc_type == 'Mastercard'" class="w-40px" src="../../../../../../../assets/LOGOS/mastercardLogo.svg" alt="Mastercard" />
              <img *ngIf="pm.cc_type == 'American Express'" class="w-40px" src="../../../../../../../assets/LOGOS/amexLogo.svg" alt="American Express" />
              <img *ngIf="pm.cc_type == 'Diners Club/Carte Blanche' || pm.cc_type == 'Diners Club'" class="w-40px" src="../../../../../../../assets/LOGOS/dinersClubLogo.svg" alt="Diners Club" />
              <img *ngIf="pm.cc_type == 'UnionPay'" class="w-40px" src="../../../../../../../assets/LOGOS/unionpayLogo.svg" alt="UnionPay" />
              <img *ngIf="pm.cc_type == 'Discover'" class="w-40px" src="../../../../../../../assets/LOGOS/discoverLogo.svg" alt="Discover" />
              <img *ngIf="pm.cc_type == 'JCB'" class="w-40px" src="../../../../../../../assets/LOGOS/jcbLogo.svg" alt="JCB" />
            </p>
            <p id="p2" class="{{type?'pd-l-1-wv text-center-start':'pd-l-1 text-center-end'}}  font--13 text-sub-color-3 font-weight-400">
              * {{pm.suffix}}
            </p>
          </ng-container>
          <!-- <p id="p3" class="font--13 text-sub-color-3 font-weight-400 text-center-end">
              {{
              subsForm.get("paymentDetails").get("availablePaymentMethodSelection")
              ?.value?.bill_address1
              }}
            </p> -->
        </div>
      </div>
      <!-- <div class="margin-right-10">
        <mat-checkbox class="example-margin" [(ngModel)]="checked">Automatically Renew Payment</mat-checkbox>
      </div> -->
    </div>
  </div>
  <div class="{{type? 'sub-container-wv':'sub-container'}} ">
    <div class="divider"></div>
  </div>
  <div class="{{type? 'sub-container-wv':'sub-container'}} " *ngIf="discountEligibility">
    <!-- <div class="row"> -->
    <div *ngIf="type != 'webview'" class="col-sm-12">
      <div class="form-group d-flex flex-column">
        <label class="text-color">Enter Promo Code</label>
        <input class="form-input" placeholder="Save20" />
        <div class="d-flex align-center justify-content-center">
          <button class="standard-btn primar-btn">Apply</button>
        </div>
        <!-- <select class="form-select" (change)="onCouponSelected($event)">
            <option value="select coupon" selected>Save 20</option>
            <option *ngFor="let coupon of couponList; trackBy: trackByNgForItem" [value]="coupon.couponCode">
              {{ coupon.couponCode }} - {{ coupon.couponDesc }}
            </option>
          </select> -->
      </div>
      <!-- </div> -->
    </div>
    <div *ngIf="type == 'webview'">
      <div class="promo-section">
        
        <p class="promo-text">Enter Promo Code</p>
        
        <div class="promo-input form-group">
          <input class="form-control placeholder-color" placeholder="Save20" />
          <span class="promo-button-container">
            <button class="button-wv">Apply</button>
          </span>
        </div>

      </div>
    </div>
  </div>
  <div class="{{type? 'sub-container-wv':'sub-container'}} " *ngIf="discountEligibility">
    <div class="divider"></div>
  </div>

  <div class="{{type? 'sub-container-wv':'sub-container'}} ">
    <div>
      <div class="{{type? 'sub-container-wv':'sub-container'}} padding-zero">
        <p id="p1" class="{{type? 'pd-l-1-wv pd-b-7-wv title-info-wv red-color-wv':'pd-l-1 pd-b-7 title-info red-color'}} padding-zero">
          Billing Details
        </p>
      </div>


      <div class="{{type? 'sub-container-wv':'sub-container'}}">
        <div></div>
        <div class="{{type?'sub-container-column-wv':'sub-container-column'}} ">
          <div class="{{type?'sub-container-wv-width-300':'sub-container-width-300'}} padding-zero">
            <p id="p1" class="font-14 text-color font-weight-400">Billing Date:</p>
            <p id="p2" class="font--13 text-color font-weight-400">
              <!-- {{nextBillingDate}} -->
              {{
              subsForm.get("packageDetails")?.get("availablePackageSelection")?.value
              ?.subsStartDate
              }}
            </p>
          </div>
          <div class="{{type?'sub-container-wv-width-300':'sub-container-width-300'}} padding-zero">

            <p id="p1" class="font--13 grey-color font-weight-400">Subtotal:</p>
            <p id="p2" class="font--13 grey-color font-weight-400">
              {{ changePlanInfo?.totalChargesBeforeTax | currency}}
            </p>
          </div>
          <div class="{{type?'sub-container-wv-width-300':'sub-container-width-300'}} padding-zero">
            <p id="p1" class="font--13 grey-color font-weight-400">
              Discount Applied:
            </p>
            <p id="p2" class="font--13 grey-color font-weight-400">
              {{ changePlanInfo?.totalCredit | currency}}
            </p>
          </div>
          <div class="{{type?'sub-container-wv-width-300':'sub-container-width-300'}} padding-zero">
            <p id="p1" class="font--13 grey-color font-weight-400">Estimated Tax:</p>
            <p id="p2" class="font--13 grey-color font-weight-400">
              {{ changePlanInfo?.totalTaxCharges | currency}}
            </p>
          </div>
          <!-- <div class="{{type? 'sub-container-wv':'sub-container'}} padding-zero">
          <p id="p1" class="font-12 text-color font-weight-400">Refund Amount:</p>
          <p id="p2" class="font-12 text-color font-weight-400">$0.00</p>
        </div> -->
          <div class="{{type?'sub-container-wv-width-300':'sub-container-width-300'}} padding-zero ">
            <div class="divider"></div>
          </div>
          <!-- <hr class="pading-zero full-width show-on-mobile"> -->
          <div class="{{type?'sub-container-wv-width-300 padding-zero-wv':'sub-container-width-300 padding-zero'}} ">
            <p id="p1" class="{{type? 'title-info-wv red-color-wv':'title-info red-color'}}">Amount Due:</p>
            <p id="p2" class="{{type? 'title-info-wv ' : 'font-weight-400'}} font--13 text-color" >{{changePlanInfo?.total | currency}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="footer {{type?'mobile':''}}">
    <p class="noticeText font--13 text-color font-weight-400">
      Starting on the billing date you will be charged the amount above plus applicable taxes. You may cancel at any time online via the {{this.isAcura?"AcuraLink":"HondaLink"}} app or myGarage website.
    </p>
  </div>

  <!-- Not in scope for current deployment of GDO -->
  <!-- <div class="footer {{type?'mobile':''}}">
    <mat-checkbox [(ngModel)]="checked" *ngIf="packageDuration && (packageDuration == '3 Year'||packageDuration == '5 Year')" (change)="checkAutoRenew($event)"></mat-checkbox>
    <p class="noticeText font--13 text-color font-weight-400">

      <span *ngIf="packageDuration && (packageDuration == '3 Year'||packageDuration == '5 Year')">
        <strong>Automatic Renewal Notice:</strong>
        Please check this box to acknowledge that starting today you will be charged the amount above plus applicable taxes every year until you cancel. You can cancel at any time by selecting Cancel below, or by calling us at +1 (888) 528-7876, or online via the {{ isAcura ? 'AcuraLink' : 'HondaLink'}} App or {{ isAcura ? 'AcuraLink' : 'HondaLink'}} website.
      </span> -->

      <!-- <span *ngIf="packageDuration && packageDuration == 'Monthly'">
        <strong>Automatic Renewal Notice:</strong>
        Starting today you will be charged the amount above plus applicable taxes every month until you cancel. You can
        cancel at any time by selecting Cancel below, or by calling us at
        +1 (888) 528-7876, or online via the {{ isAcura ? 'AcuraLink' : 'HondaLink'}} App or
        {{ isAcura ? 'AcuraLink' : 'HondaLink'}} website.
      </span> -->
    <!-- </p> -->

    <!-- <p class="font-12 text-color font-weight-400 text-center-align">
        ** Starting today you will be charged $10.00/month plus applicable taxes
        on a recurring basis. You can cancel anytime.
      </p>
      <p class="font-12 text-color font-weight-400 text-center-align">
        You can cancel your subscription at any time via this website, the mobile
        app, or by calling us at XXX-XXX-XXXX
      </p> -->
  <!-- </div> -->

</div>
</div>

  <div *ngIf="type" class="container-buttons-wv flex-column-wv">
    <!-- <button class="button-with-radius" (click)="onCancel()" mat-button matStepperPrevious>
        Cancel
      </button> -->
    <button mat-button class="button-with-radius" matStepperNext (click)="onConfirmPurchase()">
      Complete Purchase
    </button>
    <button class="button-wv" mat-button matStepperPrevious>
      Previous
    </button>
  </div>


  
<div *ngIf="!type" class="container-buttons">
  <button class="danger-btn" (click)="onCancel()" mat-button matStepperPrevious>Cancel</button>
  <button class="primar-btn" mat-button matStepperPrevious>Previous</button>
  <button mat-button class="primar-btn" matStepperNext (click)="onConfirmPurchase()">
    Complete Purchase
  </button>
</div>